import {authActionTypes} from "../actions/actionTypes";

const initialState = {
    loginInfo: null,
    verifyToken: null,
    verifyName: null,
    userName: null,
    user: null,
    mfaEnabled: null,
    mfaType: null,
    mfaAction: null,
    mfaSetupParams: null,
    mfaNotEnabledGracePeriodEnded: null,
    mfaToken: null,
    rememberDeviceDays: 0,
    mfaTypesConfigured: null,
    mfaEmailSetUpped: null,
};

export const authReducer = (state = initialState, action) => {
    switch (action.type) {
        case authActionTypes.SET_LOGIN:
            return {
                ...state,
                loginInfo: action.payload,
                userName: action.payload.userName || action.payload.username || state.userName || [action.payload.firstName, action.payload.lastName].filter(Boolean).join(" "),
                user: (action.payload.firstName || action.payload.lastName)
                    ? {
                        firstName: action.payload.firstName,
                        lastName: action.payload.lastName
                    }
                    : state.user,
            }
        case authActionTypes.SET_LOGOUT:
            return {...initialState}
        case authActionTypes.SET_VERIFY_NAME:
            return {
                ...state,
                verifyName: action.payload,
            }
        case authActionTypes.SET_VERIFY_TOKEN:
            return {
                ...state,
                verifyToken: action.payload,
            }
        case authActionTypes.CLEAR_VERIFY:
            return {
                ...state,
                verifyToken: null,
                verifyName: null
            }
        case authActionTypes.METADATA_SET:
            return {
                ...state,
                userName: action.payload.userName,
                mfaEnabled: action.payload.mfaEnabled,
                mfaNotEnabledGracePeriodEnded: action.payload.mfaNotEnabledGracePeriodEnded,
            }
        case authActionTypes.METADATA_SETUP:
            return {
                ...state,
                mfaSetupParams: action.payload.mfaSetupParams,
            }
        case authActionTypes.MFA_TYPE_SET:
            return {
                ...state,
                mfaType: action.payload.mfaType,
            }
        case authActionTypes.MFA_TYPES_CONFIGURED_SET:
            return {
                ...state,
                mfaTypesConfigured: action.payload.mfaTypesConfigured
            }
        case authActionTypes.MFA_EMAIL_SET_UPPED:
            return {
                ...state,
                mfaEmailSetUpped: action.payload.mfaEmailSetUpped
            }
        case authActionTypes.MFA_PREPARE_SET:
            return {
                ...state,
                mfaToken: action.payload.mfaToken
            }
        case authActionTypes.SET_NEW_TOKEN: {
            const {authToken, ...rest} = state.loginInfo || {};
            return {
                ...state,
                loginInfo: {...rest, ...action.payload, mfaToken: null},
                mfaToken: null
            };
        }
        case authActionTypes.MFA_IS_SETUP:
            return {
                ...state,
                mfaEnabled: action.payload.mfaEnabled,
            }
        case authActionTypes.CLEAR_TOKEN:
            return {
                ...state,
                mfaToken: null
            }
        case authActionTypes.MFA_REMEMBER_DEVICE_DAYS_SET:
            return {
                ...state,
                rememberDeviceDays: action.payload.rememberDeviceDays
            }
        default:
            return state
    }
};
